import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.import-csv', {
        url: '/import-csv',
		views: {
            '@company.sharing-center': 'companySharingCenterImportCsv'
        },
        resolve: {
			companyId,
			importFileTypes
        },
    });
}
/** @ngInject */
function importFileTypes(PasswordManagers) {
    return PasswordManagers.getImportFileTypes();
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/import-csv/import-csv.state.js